import ApiClient from './apiClient'
import {
  ModalEvent,
  requestPostModalEventLog,
} from '../types/modalEvent'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getModalEventList = async (): Promise<any> => ApiClient.get(
  '/api/v1/renderer/modal_event',
  (result: ModalEvent[]) => result,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postModalEventLog = async (params: requestPostModalEventLog): Promise<any> => ApiClient.post(
  '/api/v1/renderer/modal_event',
  () => {
    // do nothing
  },
  params,
)
